module.exports = __webpack_public_path__ + "img/6bf457e.jpg";